type Props = {
  classes?: string;
  children: React.ReactNode;
};

const Label = ({ classes = 'text-black-75', children }: Props) => {
  return <div className={`${classes}`}>{children}</div>;
};

export default Label;
